import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import UpdatePaymentMethodNotification from '../DebtPaymentComponents/updatePaymentMethodNotification';
import EmailNotification from '../DebtPaymentComponents/emailNotification';
import PaymentNotification from '../DebtPaymentComponents/paymentNotification';
import {successEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import ConfettiComponent from '../../../../utilities/confetti';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {CSSTransition} from 'react-transition-group';
import '../debtPayment.scss';

const DebtPaymentSuccess = (props) => {
  const [mount, setMount] = useState(false);

  useEffect(() => {
    if (props.currentStep === successEnum.PAYMENTSUCCESS) {
      setMount(true);
      if (props.noPaymentMethod) {
        gaEvent(
          gaParams.DEBT_PAYMENT_SHOW_PAMENTSUCCESS_WITHPMNTMETHODLNK.category,
          gaParams.DEBT_PAYMENT_SHOW_PAMENTSUCCESS_WITHPMNTMETHODLNK.eventType,
          gaParams.DEBT_PAYMENT_SHOW_PAMENTSUCCESS_WITHPMNTMETHODLNK.eventParams,
        );
      } else {
        gaEvent(
          gaParams.DEBT_PAYMENT_SHOW_PAMENTSUCCESS_NOPMNTMETHODLNK.category,
          gaParams.DEBT_PAYMENT_SHOW_PAMENTSUCCESS_NOPMNTMETHODLNK.eventType,
          gaParams.DEBT_PAYMENT_SHOW_PAMENTSUCCESS_NOPMNTMETHODLNK.eventParams,
        );
      }
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  let mainImg = require('../images/icons-ok-done.svg');

  return (
    <CSSTransition key={9} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <ConfettiComponent />
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='התשלום התקבל, תודה!' classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='justify-content-md-center'>
          <Col lg='4' className={props.isMobile ? '' : 'pr-0 pl-0'}>
            <PaymentNotification
              authNumber={props.paymentData.receptionNo}
              amount={props.paymentData.amount}
              numOfPayments={props.paymentData.paymentNo}
            />
          </Col>
        </Row>
        {props.noPaymentMethod && (
          <Row className='justify-content-md-center'>
            <Col lg='4' className={props.isMobile ? '' : 'pr-0 pl-0'}>
              <UpdatePaymentMethodNotification updatePaymentMethod={props.updatePaymentMethod} />
            </Col>
          </Row>
        )}
        {props.email && (
          <Row className='justify-content-md-center'>
            <Col lg='4' className={props.isMobile ? '' : 'pr-0 pl-0'}>
              <EmailNotification email={props.email} />
            </Col>
          </Row>
        )}
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto'>
            <BtnSubmit isBusiness formid='' text='סיום' onclick={props.onclick} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default DebtPaymentSuccess;
